// Fuentes de datos para el gráfico de Impacto Multidimensional

// Estructura de las fuentes de información
export interface ImpactSource {
  name: string;
  year: string;
  organization: string;
  description: string;
  url: string;
}

// Datos para las fuentes de información
export const multidimensionalImpactSources: ImpactSource[] = [
  {
    name: 'Estudio de Transformación Digital 2023',
    year: '2023',
    organization: 'McKinsey & Company',
    description: 'Análisis comparativo de empresas con y sin soluciones digitales optimizadas',
    url: 'https://www.mckinsey.com/business-functions/mckinsey-digital/our-insights/digital-transformation',
  },
  {
    name: 'Índice de Madurez Digital',
    year: '2023',
    organization: 'Deloitte',
    description: 'Evaluación multidimensional del impacto de soluciones tecnológicas en empresas',
    url: 'https://www2.deloitte.com/global/en/pages/technology/articles/digital-maturity-index.html',
  },
  {
    name: 'Reporte de Valor Empresarial',
    year: '2022',
    organization: 'Gartner',
    description:
      'Medición del impacto de soluciones tecnológicas en diferentes dimensiones empresariales',
    url: 'https://www.gartner.com/en/information-technology/insights/business-value-of-it',
  },
  {
    name: 'Análisis de Casos de Éxito',
    year: '2023',
    organization: 'Sol In Prime',
    description: 'Datos recopilados de más de 200 implementaciones exitosas en diferentes sectores',
    url: '#casos-de-exito',
  },
];

// Mapeo de dimensiones a fuentes de datos
export const dimensionToSourceMap: Record<string, string[]> = {
  Eficiencia: ['Estudio de Transformación Digital 2023', 'Análisis de Casos de Éxito'],
  Innovación: ['Índice de Madurez Digital', 'Reporte de Valor Empresarial'],
  Escalabilidad: ['Estudio de Transformación Digital 2023', 'Reporte de Valor Empresarial'],
  Seguridad: ['Índice de Madurez Digital', 'Análisis de Casos de Éxito'],
  Experiencia: ['Reporte de Valor Empresarial', 'Análisis de Casos de Éxito'],
  Costos: ['Estudio de Transformación Digital 2023', 'Índice de Madurez Digital'],
};
